<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import {Link} from 'svelte-routing'
    import eggs from './eggs.svg'
    import units from './units.svg'
    import rightIcon from './right.svg'
    import {getItemsCount} from 'src/components/cabinet/#services/inventory'
    import {checkMetamaskNft} from 'src/components/cabinet/#services/evmAdapter'
    import {showAlert} from 'src/components/#common/alert/store'
    import {userProfile} from 'src/services/auth'
    import {stringToHex} from 'src/components/#common/helpers/helpers'

    getItemsCount.reset()
    getItemsCount.send()

    const metamaskIsAvailable = typeof window != 'undefined' && typeof window?.ethereum != 'undefined'

    async function connectMetamask() {
        let data = []
        const wallets = await window.ethereum.request({method: "eth_requestAccounts"})

        for (const wallet of wallets) {
            try {
                if (!$userProfile.userId) break

                const messageHash = stringToHex('Update NFT list from '+wallet+' for user ('+$userProfile.userId+') '+
                    Date.now())

                const signature = await window.ethereum.request({
                    "method": "personal_sign",
                    "params": [ messageHash, wallet ]
                })

                data.push({ messageHash, signature, wallet })
            } catch (err) {
                console.error(err.message)
                continue
            }
        }

        if (data.length) {
            try {
                await checkMetamaskNft.request({ data: { data: data } })

                showAlert.set({
                    status: 'success',
                    text: 'Metamask successfully connected. NFT list loading...'
                })
            } catch (err) {
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            }
        } else {
            showAlert.set({
                status: 'error',
                text: 'Metamask connected, but no access to the wallet. Please try again.'
            })
        }
    }
</script>

<svelte:head>
    <title>My inventory</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="page-title">My inventory
                {#if metamaskIsAvailable && process.env.SHOW_BROWSER_LOG}
                    <button class="btn btn-primary metamask-btn" on:click={connectMetamask}><span>Connect MetaMask</span></button>
                {:else if !metamaskIsAvailable && process.env.SHOW_BROWSER_LOG}
                    <a href="https://metamask.app.link/dapp/realis.network" class="btn btn-primary metamask-btn"><span>Connect MetaMask</span></a>
                {/if}
            </div>
            {#if metamaskIsAvailable && process.env.SHOW_BROWSER_LOG}
                <button class="btn btn-primary metamask-btn-mobile" on:click={connectMetamask}><span>Connect MetaMask</span></button>
            {:else if !metamaskIsAvailable && process.env.SHOW_BROWSER_LOG}
                <a href="https://metamask.app.link/dapp/realis.network" class="btn btn-primary metamask-btn-mobile"><span>Connect MetaMask</span></a>
            {/if}
            <Alert />
            <div class="row inventory-categories">
                {#if !$getItemsCount.hasValue && $getItemsCount.loading}
                    <div class="col">Loading...</div>
                {:else if !$getItemsCount.hasValue && $getItemsCount.error}
                    <div class="col">Something went wrong. Try refreshing the page.</div>
                {:else if $getItemsCount.hasValue}
                    {#if $getItemsCount.value?.lootboxes > 0}
                        <div class="col-md-6 col-xl-4 col-xxl-3">
                            <Link to="inventory/eggs" class="inventory-category">
                                <div class="inventory-card">
                                    <div class="name">Eggs
                                        {#if $getItemsCount.value?.lootboxes && $getItemsCount.value.lootboxes > 0}
                                            <div class="count">{$getItemsCount.value.lootboxes}</div>
                                        {/if}
                                    </div>
                                    <div class="nft-icon"><img src="{eggs}" alt="nft"></div>
                                    <div class="view-all-btn"><span>View</span> <img src="{rightIcon}" alt=""></div>
                                </div>
                            </Link>
                        </div>
                    {/if}
                    {#if $getItemsCount.value?.units > 0}
                        <div class="col-md-6 col-xl-4 col-xxl-3">
                            <Link to="inventory/units" class="inventory-category">
                                <div class="inventory-card">
                                    <div class="name">Units
                                        {#if $getItemsCount.value?.units && $getItemsCount.value.units > 0}
                                            <div class="count">{$getItemsCount.value.units}</div>
                                        {/if}
                                    </div>
                                    <div class="nft-icon"><img src="{units}" alt="nft"></div>
                                    <div class="view-all-btn"><span>View</span> <img src="{rightIcon}" alt=""></div>
                                </div>
                            </Link>
                        </div>
                    {/if}
                    {#if $getItemsCount.value?.lootboxes === 0 && $getItemsCount.value?.units === 0}
                        <div class="col">Empty</div>
                    {/if}
                {/if}
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .btn.metamask-btn {
        padding: 16px 25px;
        float: right;
    }

    .inventory-categories {
        margin: 30px -12px 26px;
    }

    .inventory-categories :global(.inventory-category) {
        display: block;
        height: 250px;
        background: #26244D;
        border: 2px solid #494591;
        border-radius: 20px;
        padding: 15px;
        text-align: center;
        text-decoration: none;
        margin-bottom: 24px;
        transition: .2s;
    }

    .inventory-categories :global(.inventory-category:hover) {
        background: #353064;
    }

    .name {
        color: white;
        font-size: 18px;
        margin: 20px 0;
        display: flex;
        justify-content: center;
    }

    .count {
        display: block;
        font-size: 10px;
        height: 15px;
        min-width: 15px;
        background: #ff5d1c;
        padding: 0 4px;
        border-radius: 10px;
        line-height: 15px;
        text-shadow: 0 0 3px rgba(14, 14, 14, 0.3);
        margin: -3px 0 3px 3px;
        font-weight: 500;
    }

    .view-all-btn {
        font-size: 16px;
        line-height: 20px;
        margin-top: 20px;
        color: white;
    }

    .view-all-btn img {
        vertical-align: top;
        margin-top: 3px;
        transition: .2s;
    }

    :global(.inventory-category:hover .view-all-btn img) {
        margin-right: -4px;
        margin-left: 4px;
    }

    .metamask-btn-mobile {
        display: none;
    }

    @media(max-width: 991px) {
        .btn.metamask-btn {
            padding: 12px 15px;
            margin-top: -5px;
        }
    }

    @media(max-width: 767px) {
        .name {
            margin: 8px 0 18px;
        }

        .view-all-btn {
            margin-top: 15px;
        }

        .inventory-categories {
            margin: 0 -12px;
        }

        .inventory-categories :global(.inventory-category) {
            height: 210px;
            margin-bottom: 12px;
        }

        .btn.metamask-btn {
            display: none;
        }

        .metamask-btn-mobile {
            display: block;
            margin: -12px 0 15px;
            width: 100%;
        }
    }
</style>
